/**
 * Formats a display name for a container-type waste exchange.
 * @param {{ containerNumber?: string|number, containerName?: string }} exchange
 * @returns {string}
 */
export function formatWasteExchangeContainerName(exchange) {
  return `Kontener ${exchange?.containerNumber ?? ""} - ${exchange?.containerName ?? ""}`.trim();
}
